"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Holidays = exports.Holiday = void 0;
var year_1 = require("./year");
var Holiday = /** @class */ (function () {
    function Holiday(name, getter, firstObservance) {
        this.name = name;
        this.getter = getter;
        this.firstObservance = firstObservance;
    }
    return Holiday;
}());
exports.Holiday = Holiday;
var Holidays = /** @class */ (function () {
    function Holidays() {
    }
    Holidays.getHoliday = function (name) {
        return Holidays.all.find(function (holiday) { return holiday.name === name; });
    };
    Holidays.newYearsDay = new Holiday("New Year's Day", function (year) { return new year_1.default(year).newYearsDay; }, 1871);
    Holidays.martinLutherKingJrDay = new Holiday('Martin Luther King Jr. Day', function (year) { return new year_1.default(year).martinLutherKingJrDay; }, 1998);
    Holidays.washingtonsBirthday = new Holiday("Washington's Birthday", function (year) { return new year_1.default(year).washingtonsBirthday; }, 1885);
    Holidays.goodFriday = new Holiday('Good Friday', function (year) { return new year_1.default(year).goodFriday; }, 1920);
    Holidays.memorialDay = new Holiday('Memorial Day', function (year) { return new year_1.default(year).memorialDay; }, 1971);
    Holidays.juneteenthNationalIndependenceDay = new Holiday('Juneteenth National Independence Day', function (year) { return new year_1.default(year).juneteenthNationalIndependenceDay; }, 2022);
    Holidays.independenceDay = new Holiday('Independence Day', function (year) { return new year_1.default(year).independenceDay; }, 1870);
    Holidays.laborDay = new Holiday('Labor Day', function (year) { return new year_1.default(year).laborDay; }, 1894);
    Holidays.columbusDay = new Holiday('Columbus Day', function (year) { return new year_1.default(year).columbusDay; }, 1937);
    Holidays.veteransDay = new Holiday('Veterans Day', function (year) { return new year_1.default(year).veteransDay; }, 1954);
    Holidays.thanksgivingDay = new Holiday('Thanksgiving Day', function (year) { return new year_1.default(year).thanksgivingDay; }, 1941);
    Holidays.christmasDay = new Holiday('Christmas Day', function (year) { return new year_1.default(year).christmasDay; }, 1870);
    Holidays.all = [
        Holidays.newYearsDay,
        Holidays.martinLutherKingJrDay,
        Holidays.washingtonsBirthday,
        Holidays.goodFriday,
        Holidays.memorialDay,
        Holidays.juneteenthNationalIndependenceDay,
        Holidays.independenceDay,
        Holidays.laborDay,
        Holidays.columbusDay,
        Holidays.veteransDay,
        Holidays.thanksgivingDay,
        Holidays.christmasDay,
    ];
    return Holidays;
}());
exports.Holidays = Holidays;
